
import {of as observableOf, Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {CguTypeEnum} from '../components/conditions-generales/cgu.model';
import { map, tap } from 'rxjs/operators';

@Injectable()
export class CguService {

    private cguText: string;

    private cguTypeEnum: CguTypeEnum;

    private readonly COMMON_URL_CGU = '/api/static';

    constructor(
        private httpClient: HttpClient
    ) {
    }

    getCgu(cguTypeEnum: CguTypeEnum): Observable<string> {
        if (this.cguText && this.cguTypeEnum === cguTypeEnum) {
            return observableOf(this.cguText);
        }

        const cguUrl = `${this.COMMON_URL_CGU}/${cguTypeEnum}.xml`;

        /* return this.httpClient.get(cguUrl)
            .map(res => {
                this.cguText = res.text();
                this.cguTypeEnum = cguTypeEnum;
                return this.cguText;
            }); */

        return this.httpClient.get(cguUrl, {
            responseType: 'text'
        }).pipe(
            tap(() => this.cguTypeEnum = cguTypeEnum),
            map(data => this.cguText = data));
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/services/cgu.service.ts